import { render, staticRenderFns } from "./CurveSelection.vue?vue&type=template&id=2c430dac&scoped=true"
import script from "./CurveSelection.vue?vue&type=script&lang=ts"
export * from "./CurveSelection.vue?vue&type=script&lang=ts"
import style0 from "./CurveSelection.vue?vue&type=style&index=0&id=2c430dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c430dac",
  null
  
)

export default component.exports